import { gql } from '@apollo/client';

// Selecting `invoices` is what makes getDocs build the history (#36679).
export const GET_INVOICE_HISTORY = gql`
  query GetInvoiceHistory($accountId: ID!) {
    documents: getDocs(accountId: $accountId) {
      invoices {
        path
        policyId
        lastModified
        channel
        recipient
        amountDue
        dueDate
        installmentNumber
        totalInstallments
        invoiceNumber
      }
    }
  }
`;
